/**
 * Competition template rows (kwata_final_competitions) — drill-down helpers.
 */

import { countByField } from './involvementDrilldown';

export function normalizeStr(str) {
  if (str == null || str === '') return '';
  return String(str).trim().replace(/\s+/g, ' ');
}

/**
 * All competition entries for a given competition name (exact match on competition_name).
 */
export function filterCompetitionsByName(competitions, competitionName) {
  const t = normalizeStr(competitionName);
  if (!t) return [];
  return (competitions || []).filter((c) => normalizeStr(c.competition_name) === t);
}

/**
 * Aggregates for charts + deduped team list.
 */
export function aggregateCompetitionEntries(rows) {
  const list = rows || [];
  const byRegion = countByField(list, 'region');
  const byAge = countByField(list, 'age_group');
  const byBall = countByField(list, 'ball_type');
  const byScoring = countByField(list, 'scoring_method');
  const catKey = (r) =>
    `${r.cricket_type || '—'} · ${r.gender || '—'}`;
  const byCategory = {};
  list.forEach((r) => {
    const k = catKey(r);
    byCategory[k] = (byCategory[k] || 0) + 1;
  });
  const byCategoryArr = Object.entries(byCategory)
    .map(([name, value]) => ({ name, value }))
    .sort((a, b) => b.value - a.value);

  const teams = [...new Set(list.map((r) => normalizeStr(r.team_name)).filter(Boolean))].sort();

  return {
    byRegion,
    byAge,
    byBall,
    byScoring,
    byCategoryArr,
    teams,
    rowCount: list.length,
  };
}
